<template>
	<div class="subcontract_box animate__animated animate__fadeIn">
		<div class="subcontract">
			<div class="search_box">
				<div class="text">分包单位</div>
				<div class="search_btn" @click="fnOpenAddSubcontract"><span>新增分包单位</span></div>
				<div class="search_btn upload" @click="fnUploadSubcontractGy"><span>上传贵阳市建委</span></div>
			</div>
			<div class="cont_list">
				<div class="list_title">
					<div class="title_item">企业信息统一社会代码</div>
					<div class="title_item">分包类型</div>
					<div class="title_item">身份证号码</div>
					<div class="title_item">分包项目负责人手机号</div>
					<div class="title_item">现场负责人姓名</div>
					<div class="title_item">在场情况</div>
					<div class="title_item">企业名称</div>
					<div class="title_item">计划进场时间</div>
					<div class="title_item">计划出场时间</div>
					<div class="title_item">上传状态</div>
					<div class="title_item">创建时间</div>
					<div class="title_item">操作</div>
				</div>
				<div class="list_boxes">
					<div class="list_box">
						<div v-if="subcontractList">
							<div class="box_line" v-for="(item, index) in subcontractList" :key="index">
								<div class="list_item">{{ item.unitCode }}</div>
								<div class="list_item">{{ roleTypeList[item.roleType] }}</div>
								<div class="list_item">{{ item.subHeadIdcard }}</div>
								<div class="list_item">{{ item.subHeadTel }}</div>
								<div class="list_item">{{ item.subHeadName }}</div>
								<div class="list_item">{{ subsituationList[item.subsituation] }}</div>
								<div class="list_item" :title="item.enterpriseName"><span>{{ item.enterpriseName }}</span></div>
								<div class="list_item">{{ item.inTimeStr }}</div>
								<div class="list_item">{{ item.outTimeStr }}</div>
								<div class="list_item">{{ item.upload_at ? '已上传—' + item.upload_at : '未上传' }}</div>
								<div class="list_item">{{ item.create_at }}</div>
								<div class="list_item">
									<div>
										<button class="item_btn blue" @click="fnOpenEditSubcontract(item)"><span>编辑</span></button>
										<button class="item_btn red" @click="fnDelete(item)"><span>删除</span></button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- 添加编辑分包单位弹窗 -->
			<div class="dialog_subcontract" v-if="subcontractWindow">
				<el-dialog :custom-class="'animate__animated animate__fadeIn'" :modal="false" :title="subcontractTitle" center :visible.sync="subcontractWindow">
					<div class="reason_body">
						<div class="body_item">企业信息统一社会代码</div>
						<div class="body_item"><input type="text" class="input_box" v-model="form.unitCode" placeholder="请输入企业信息统一社会代码" /></div>
					</div>
					<div class="reason_body">
						<div class="body_item">分包类型</div>
						<div class="body_item">
							<el-select v-model="form.roleType" :popper-append-to-body="false" filterable placeholder="请选择">
								<el-option v-for="(item, i) in roleTypeList" :key="i" :label="item" :value="i"></el-option>
							</el-select>
						</div>
					</div>

					<div class="reason_body">
						<div class="body_item">身份证号码</div>
						<div class="body_item"><input type="text" class="input_box" v-model="form.subHeadIdcard" placeholder="请输入身份证号码" /></div>
					</div>
					<div class="reason_body">
						<div class="body_item">分包项目负责人手机号</div>
						<div class="body_item"><input type="text" class="input_box" v-model="form.subHeadTel" placeholder="请输入分包项目负责人手机号" /></div>
					</div>
					<div class="reason_body">
						<div class="body_item">现场负责人姓名</div>
						<div class="body_item"><input type="text" class="input_box" v-model="form.subHeadName" placeholder="请输入现场负责人姓名" /></div>
					</div>
					<div class="reason_body">
						<div class="body_item">在场情况</div>
						<div class="body_item">
							<el-select v-model="form.subsituation" :popper-append-to-body="false" filterable placeholder="请选择">
								<el-option v-for="(item, i) in subsituationList" :key="i" :label="item" :value="i"></el-option>
							</el-select>
						</div>
					</div>

					<div class="reason_body">
						<div class="body_item">企业名称</div>
						<div class="body_item"><input type="text" class="input_box" v-model="form.enterpriseName" placeholder="请输入企业名称" /></div>
					</div>
					<div class="reason_body">
						<div class="body_item">计划进场时间</div>
						<div class="body_item"><el-date-picker value-format="yyyy-MM-dd" v-model="form.inTimeStr" type="date" placeholder="选择日期"></el-date-picker></div>
					</div>
					<div class="reason_body">
						<div class="body_item">计划出场时间</div>
						<div class="body_item"><el-date-picker value-format="yyyy-MM-dd" v-model="form.outTimeStr" type="date" placeholder="选择日期"></el-date-picker></div>
					</div>

					<div slot="footer" class="dialog-footer">
						<div class="btn_line">
							<div class="search-btn red" @click="subcontractWindow = false"><span>取消</span></div>
							<div class="search-btn" @click="fnAddSubcontract"><span>保存</span></div>
						</div>
					</div>
				</el-dialog>
			</div>

            <!-- 上传失败信息弹窗-->
            <div class="dialog_perError" v-if="showErrorInfo">
                <el-dialog :custom-class="'animate__animated animate__fadeIn'" top="20vh" :modal="false" title="分包单位上传失败" :visible.sync="showErrorInfo" center>
                    <div class="cont_list">
                        <div class="list_boxes">
                            <div class="list_box">
                                <div v-if="errorInfoList">
                                    <div class="box_line" v-for="(item,index) in errorInfoList" :key="index">
                                        <div class="list_item">{{ item.msg }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div slot="footer" class="dialog-footer">
                        <div class="btn_line">
                            <div class="search-btn red" @click="showErrorInfo = false"><span>关闭</span></div>
                        </div>
                    </div>
                </el-dialog>
            </div>
		</div>
	</div>
</template>

<script>
import { fnRequestPlatform } from '@/utils/upload';
import request from '@/utils/request';
export default {
	data() {
		return {
            showErrorInfo:false, //上传错误弹窗
            errorInfoList:[], // 错误列表
			subcontractTitle: '新增分包单位', // 弹窗名称
			editId: '', // 编辑id
			form: {
				unitCode: '',
				roleType: 'LABOR_SUB',
				subHeadIdcard: '',
				subHeadTel: '',
				subHeadName: '',
				subsituation: '01',
				enterpriseName: '',
				inTimeStr: '',
				outTimeStr: ''
			},
			subcontractWindow: false, // 添加、编辑分包单位弹窗
			subcontractList: [], // 分包单位列表
			personnelList: [], // 项目下人员列表
			roleTypeList: {
				DEVICE_SUB: '设备分包',
				MATERIAL_SUB: '材料分包',
				LABOR_SUB: '劳务分包',
				PROFESSIONAL_SUB: '专业分包'
			},
			subsituationList: {
				'01': '在场',
				'02': '退场'
			}
		};
	},
	created() {
		this.fnInit();
	},
	methods: {
		// 初始化
		fnInit() {
			this.fnGetSubcontract({ region: 'gy' });
		},
		// 上传贵阳市建委
		fnUploadSubcontractGy() {
            fnRequestPlatform(
                {
                    url: '/Gy/subenterpriseSaveOrUpdate',
                    method: 'GET'
                },
                res => {
                    this.fnGetSubcontract({ region: 'gy' });

                    if(res.code === 1){
                        this.$message.success(res.data);
                        return;
                    }

                    if (typeof(res.data) !== 'string') {
                        this.errorInfoList = res.data;
                        this.showErrorInfo = true;
                    } else {
                        this.$message.error(res.data);
                    }

                }
            );
		},
		// 打开新增分包单位弹窗
		fnOpenAddSubcontract() {
			this.subcontractTitle = '新增分包单位';
			this.editId = '';
			this.form.unitCode = '';
			this.form.roleType = 'LABOR_SUB';
			this.form.subHeadIdcard = '';
			this.form.subHeadTel = '';
			this.form.subHeadName = '';
			this.form.subsituation = '01';
			this.form.enterpriseName = '';
			this.form.inTimeStr = '';
			this.form.outTimeStr = '';
            delete this.form.id 
			this.subcontractWindow = true;
		},
		// 打开编辑分包单位弹窗
		fnOpenEditSubcontract(_data) {
			this.subcontractTitle = '编辑分包单位';

			this.form.id = _data.id;
			this.form.unitCode = _data.unitCode;
			this.form.roleType = _data.roleType;
			this.form.subHeadIdcard = _data.subHeadIdcard;
			this.form.subHeadTel = _data.subHeadTel;
			this.form.subHeadName = _data.subHeadName;
			this.form.subsituation = _data.subsituation;
			this.form.enterpriseName = _data.enterpriseName;
			this.form.inTimeStr = _data.inTimeStr;
			this.form.outTimeStr = _data.outTimeStr;

			this.subcontractWindow = true;
		},
		// 获取所有分包单位
		fnGetSubcontract(_obj, _cb) {
			request({
				url: 'project/getAllRegionExtend',
				method: 'GET',
				params: _obj
			})
				.then(res => {
					_cb && _cb(res);
					this.subcontractList = res.data;
					if (this.subcontractList.length == 0) {
						this.$message.warning('暂无数据');
					}
				})
				.catch(err => {
					this.$message.error(err.data);
				});
		},
		// 分包单位搜索
		fnSearch() {
			this.fnGetSubcontract(
				{
					name: this.searchName,
					personnel_name: this.searchPersonnel_name,
					create_at: this.searchCreateDate
				},
				res => {
					this.subcontractList = res.data;
					if (this.subcontractList.length == 0) {
						this.$message.warning('暂无数据');
					}
				}
			);
		},
		// 添加、编辑分包单位
		fnAddSubcontract() {
			for (let key in this.form) {
				if (!this.form[key]) {
					console.log(key);
					this.$message.warning('参数不能为空');
					return;
				}
			}

			this.form.region = 'gy';

			request({
				url: 'project/addAllRegionExtend',
				method: 'POST',
				data: this.form
			})
				.then(res => {
					this.$message.success(res.data);
					this.subcontractWindow = false;
					this.fnGetSubcontract({ region: 'gy' });
				})
				.catch(err => {
					this.$message.error(err.data);
				});
		},
		// 删除分包单位
		fnDelete(_data) {
			request({
				url: 'subcontract/deleteSubcontract',
				method: 'POST',
				data: {
					id: _data.id
				}
			})
				.then(res => {
					this.$message.success(res.data);
					this.fnGetSubcontract({ region: 'gy' });
				})
				.catch(err => {
					this.$message.error(err.data);
				});
		}
	}
};
</script>

<style lang="scss" scoped>
@import '~@/styles/mixin.scss';

.subcontract_box {
	width: 1920px;
	height: 858px;
	position: relative;
	overflow: hidden;
	.subcontract {
		position: absolute;
		left: 0;
		right: -20px;
		top: 0;
		bottom: 0;
		overflow-x: hidden;
		overflow-y: auto;
	}
}

.search_box {
	width: 1880px;
	height: 50px;
	margin-top: 24px;
	margin-left: 20px;
	text-align: center;
	font-size: 34px;
	.search_btn {
		width: 106px;
		height: 36px;
		background: url(../../../assets/img/btn_bg_mid.png) no-repeat;
		background-size: 100% 100%;
		position: absolute;
		left: 40px;
		top: 35px;
		color: #ffffff;
		font-size: 14px;
		cursor: pointer;
		@include flex-box(center, center);
		&.upload {
			width: 130px;
			left: 160px;
		}
		span {
			margin-top: -5px;
		}
	}
}
.cont_list {
	margin-top: 29px;
	margin-left: 28px;
	width: 1864px;
	height: 755px;
	border-radius: 10px;
	background-color: rgba(29, 68, 149, 0.1);
	.list_title {
		width: 1864px;
		height: 48px;
		background: url(../../../assets/img/per_list_bg.png) no-repeat;
		background-size: 100% 100%;
		@include flex-box(flex-start, center);
		.title_item {
			height: 48px;
			@include flex-box(center, center);
			&:nth-child(1) {
				width: 180px;
				margin: 0 2px 0 40px;
			}
			&:nth-child(2) {
				width: 120px;
				margin-right: 2px;
			}
			&:nth-child(3) {
				width: 180px;
				margin-right: 2px;
			}
			&:nth-child(4) {
				width: 180px;
				margin-right: 2px;
			}
			&:nth-child(5) {
				width: 120px;
				margin-right: 2px;
			}
			&:nth-child(6) {
				width: 80px;
				margin-right: 2px;
			}
			&:nth-child(7) {
				width: 200px;
				margin-right: 2px;
			}
			&:nth-child(8) {
				width: 120px;
				margin-right: 2px;
			}
			&:nth-child(9) {
				width: 120px;
				margin-right: 2px;
			}
			&:nth-child(10) {
				width: 140px;
				margin-right: 2px;
			}
			&:nth-child(11) {
				width: 160px;
				margin-right: 2px;
			}
			&:nth-child(12) {
				width: 160px;
				margin: 0 40px 0 2px;
			}
		}
	}
	.list_boxes {
		width: 1864px;
		height: 707px;
		position: relative;
		overflow: hidden;
		.list_box {
			position: absolute;
			left: 0;
			right: -25px;
			top: 0;
			bottom: 0;
			overflow-x: hidden;
			overflow-y: auto;
			.box_line {
				width: 1784px;
				height: 70px;
				margin: 7px 0 0 40px;
				font-size: 16px;
				color: #ffffff;
				border-bottom: 1px dashed #1d4495;
				@include flex-box(flex-start, center);
				.list_item {
					height: 70px;
					text-align: center;
					@include flex-box(center, center);
					&:nth-child(1) {
						width: 180px;
						margin-right: 2px;
					}
					&:nth-child(2) {
						width: 120px;
						margin-right: 2px;
					}
					&:nth-child(3) {
						width: 180px;
						margin-right: 2px;
					}
					&:nth-child(4) {
						width: 180px;
						margin-right: 2px;
					}
					&:nth-child(5) {
						width: 120px;
						margin-right: 2px;
					}
					&:nth-child(6) {
						width: 80px;
						margin-right: 2px;
					}
					&:nth-child(7) {
						width: 200px;
						margin-right: 2px;
					}
					&:nth-child(8) {
						width: 120px;
						margin-right: 2px;
					}
					&:nth-child(9) {
						width: 120px;
						margin-right: 2px;
					}
					&:nth-child(10) {
						width: 140px;
						margin-right: 2px;
					}
					&:nth-child(11) {
						width: 160px;
						margin-right: 2px;
					}
					&:nth-child(12) {
						width: 162px;
					}
					span {
					  width: 100%;
					  cursor: pointer;
					  overflow: hidden;
					  text-overflow: ellipsis;
					  white-space: nowrap;
					}
					div {
						@include flex-box(center, center);
						.item_btn {
							width: 69px;
							height: 32px;
							line-height: 32px;
							margin: 0 2px;
							font-size: 14px;
							color: #ffffff;
							border: none;
							cursor: pointer;
							@include flex-box(center, center);
							&.blue {
								background: url(../../../assets/img/btn_bg_bsm.png) no-repeat;
								background-size: 100% 100%;
							}
							&.red {
								background: url(../../../assets/img/btn_bg_rsm.png) no-repeat;
								background-size: 100% 100%;
							}
							span {
								margin-top: -2px;
							}
						}
					}
				}
			}
		}
	}
}

.dialog_subcontract {
	>>> .el-dialog {
		width: 550px;
		height: 530px;
		margin-top: 30vh !important;
		background-color: rgba(9, 17, 32, 1);
		border: 1px solid rgba(58, 116, 221, 1);
	}
	>>> .el-form-item__label {
		color: #4db4f4;
	}
	>>> .el-dialog__title {
		color: #4db4f4;
	}
	>>> .el-dialog__close {
		color: #4db4f4;
	}
	.reason_body {
		width: 548px;
		height: 40px;
		line-height: 40px;
		color: #4db4f4;
		margin: 0 auto;
		@include flex-box();
		.body_item {
			height: 40px;
			color: #ffffff;
			&:first-child {
				width: 160px;
				text-align: center;
			}
			&:nth-child(2) {
				width: 280px;
			}
			.input_box {
				background-color: rgba(49, 88, 128, 0.6);
				width: 320px;
				height: 30px;
				line-height: 40px;
				padding-left: 15px;
				color: #4db4f4;
				font-size: 12px;
				border-radius: 2px;
				outline: none;
				border: none;
				&::-webkit-input-placeholder {
					color: rgba(77, 180, 244, 0.7);
				}
				&::-moz-placeholder {
					/* Mozilla Firefox 19+ */
					color: rgba(77, 180, 244, 0.7);
				}
				&:-moz-placeholder {
					/* Mozilla Firefox 4 to 18 */
					color: rgba(77, 180, 244, 0.7);
				}
				&:-ms-input-placeholder {
					/* Internet Explorer 10-11 */
					color: rgba(77, 180, 244, 0.7);
				}
			}

			.select_box {
				width: 320px;
				height: 30px;
				line-height: 30px;
				border-radius: 2px;
				background-color: rgba(49, 88, 128, 0.6);
			}
		}
		>>> .el-input__inner {
			background-color: rgba(49, 88, 128, 0.6);
			width: 320px;
			height: 30px;
			border-radius: 2px;
			border: none;
			color: rgba(77, 180, 244, 0.7);
			/*background: transparent;*/
			&::-webkit-input-placeholder {
				color: rgba(77, 180, 244, 0.7);
			}
			&::-moz-placeholder {
				/* Mozilla Firefox 19+ */
				color: rgba(77, 180, 244, 0.7);
			}
			&:-moz-placeholder {
				/* Mozilla Firefox 4 to 18 */
				color: rgba(77, 180, 244, 0.7);
			}
			&:-ms-input-placeholder {
				/* Internet Explorer 10-11 */
				color: rgba(77, 180, 244, 0.7);
			}
		}
		>>> .el-select__caret {
			color: rgba(77, 180, 244, 0.7);
		}
		>>> .el-select-dropdown {
			background-color: rgba(9, 17, 32, 1);
			border: 1px solid rgba(77, 180, 244, 1);
		}
		>>> .popper__arrow {
			border-bottom-color: rgba(77, 180, 244, 1) !important;
		}
		>>> .el-select-dropdown__item {
			color: rgba(77, 180, 244, 0.7);
		}
		>>> .el-select-dropdown__item:hover {
			color: #409eff;
		}
		>>> .el-select-dropdown__item.hover {
			color: #409eff;
		}
		>>> .el-input__icon {
			color: rgba(77, 180, 244, 0.7);
		}
	}
	.btn_line {
		@include flex-box(center, center);
	}
}
// 弹窗公共样式
.dialog_perError{
    .btn_line{
        @include flex-box(center,center);
    }
    >>>.el-dialog{
        width: 910px;
        height: 600px;
        // margin-top: 20vh!important;
        background-color: rgba(9, 17, 32, 1);
        border: 1px solid rgba(58,116,221,1);
    }
    >>>.el-form-item__label{
        color: #4DB4F4;
    }
    >>>.el-dialog__title{
        color: #4DB4F4;
    }
    >>>.el-dialog__close{
        color: #4DB4F4;
    }
}
.dialog_perError{
    >>>.el-dialog{
        width: 900px;
        height: 600px;
        // margin-top: 20vh!important;
    }
    .cont_list{
        width: 840px;
        height: 425px;
        color: #FFFFFF;
        font-size: 16px;
        border-radius: 10px;
        margin: 0;
        background-color: rgba(29, 68, 149, 0.1);
        .list_title{
            width: 840px;
            height: 48px;
            background: url(../../../assets/img/per_list_bg.png) no-repeat;
            background-size: 100% 100%;
            @include flex-box(flex-start,center);
            .title_item{
                height: 48px;
                @include flex-box(center,center);
                &:nth-child(1){
                    width: 156px;
                    margin: 0 4px 0 30px;
                }
                &:nth-child(2){
                    width: 156px;
                    margin-right: 4px;
                }
                &:nth-child(3){
                    width: 460px;
                    margin-right: 30px;
                }
            }
        }
        .list_boxes{
            width: 780px;
            height: 377px;
            margin-left: 30px;
            position: relative;
            overflow: hidden;
            .list_box{
                position: absolute;
                left: 0;
                right: -25px;
                top: 0;
                bottom: 0;
                overflow-x: hidden;
                overflow-y: auto;
                .box_line{
                    width: 780px;
                    height: 70px;
                    margin: 5px 0 0 0px;
                    border-bottom: 1px dashed #1D4495;
                    @include flex-box(flex-start,center);
                    &:hover{
                        background-color: rgba(49, 88, 128, 0.4);
                    }
                    .list_item{
                        color: #F56C6C;
                        height: 70px;
                        text-align: center;
                        @include flex-box(center,center);
                        &:nth-child(1){
                            width: 780px;
                        }

                        img{
                            width: 60px;
                            height: 60px;
                            border-radius: 50%;
                        }
                        span{
                            width: 100%;
                            cursor: pointer;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space:nowrap;
                        }
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/Subcontract/SubcontractGy/index.vue